import { useEffect, useId, useRef, useState } from "react";

// 라벨 옆 ⓘ 설명 — 마우스를 올리면 바로, 누르거나(터치) 키보드로 가도 보인다.
// 브라우저 title 툴팁은 1초쯤 가만히 올려 둬야 뜨고 터치 화면에서는 아예 안 떠서 직접 그린다.
// 터치는 누르면 열리고 다른 곳을 누르면(포커스가 빠지면) 닫힌다 — 누를 때 mouseenter·click 이 함께 와서 열기만 한다.
// 설명의 줄바꿈(\n)은 그대로 살린다.
// 표처럼 overflow 가 걸린 영역 안에서도 잘리지 않게 화면 기준(fixed)으로 띄우고, 스크롤하면 자리가 어긋나니 닫는다.
export default function HelpTip({ text }: { text: string }) {
  const [pos, setPos] = useState<{ top: number; left: number } | null>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const id = useId();
  const open = pos != null;

  const show = () => {
    const rect = buttonRef.current?.getBoundingClientRect();
    if (!rect) return;
    // 설명 폭(w-64 = 256px)만큼 화면 오른쪽 끝을 넘지 않게 당긴다
    setPos({
      top: rect.bottom + 4,
      left: Math.max(8, Math.min(rect.left, window.innerWidth - 264)),
    });
  };
  const hide = () => setPos(null);

  useEffect(() => {
    if (!open) return;
    const close = () => setPos(null);
    window.addEventListener("scroll", close, true);
    return () => window.removeEventListener("scroll", close, true);
  }, [open]);

  return (
    <span
      className="relative ml-1 inline-block"
      onMouseEnter={show}
      onMouseLeave={hide}
    >
      <button
        ref={buttonRef}
        type="button"
        aria-label="설명"
        aria-describedby={open ? id : undefined}
        className="cursor-help text-slate-400 hover:text-slate-600"
        onClick={show}
        onFocus={show}
        onBlur={hide}
      >
        ⓘ
      </button>
      {pos && (
        <span
          id={id}
          role="tooltip"
          style={{ top: pos.top, left: pos.left }}
          className="fixed z-30 w-64 whitespace-pre-line break-words rounded-md bg-slate-900 px-3 py-2 text-xs font-normal leading-relaxed text-white shadow-lg"
        >
          {text}
        </span>
      )}
    </span>
  );
}
